/**
 * Frases para os vínculos que bloqueiam uma exclusão.
 *
 * O `DependencyCheck` do backend devolve contagem por tipo em `details.*`, igual em todas
 * as telas que usam este helper. Mapear aqui evita que cada tela repita a tradução.
 */
const ROTULOS: Record<string, (n: number) => string> = {
  employees: (n) => `${n} ${n === 1 ? 'funcionário' : 'funcionários'}`,
  departments: (n) => `${n} ${n === 1 ? 'setor' : 'setores'}`,
  occupations: (n) => `${n} ${n === 1 ? 'cargo' : 'cargos'}`,
  companies: (n) => `${n} ${n === 1 ? 'empresa' : 'empresas'}`,
};

export function dependencyItems(details?: Record<string, unknown>): string[] {
  return Object.entries(details ?? {})
    .filter(([, n]) => Number(n) > 0)
    .map(([chave, n]) => ROTULOS[chave]?.(Number(n)) ?? `${n} ${chave}`);
}
